// extracted by mini-css-extract-plugin
export default {"bottom_navigation":"BottomNavigation_bottom_navigation__dpnp-","tab":"BottomNavigation_tab__Vx8tr"};